export const WHEEL_LEDGER_CHANGED_EVENT = "sfe-ledger-changed";

/** Ask wheel UI to reload positions/transactions after a ledger change. */
export function notifyNativeWheelRefresh(): void {
  document.dispatchEvent(new CustomEvent("sfe-wheel-refresh"));
  document.dispatchEvent(new CustomEvent(WHEEL_LEDGER_CHANGED_EVENT));
}
